/* eslint-disable */
import React, { useEffect } from "react";
import { getSharedWallets } from "../../../actions/appExpandedActions/finances";
import { connect } from "react-redux";
import DataTable from "../DataTable/DataTable";

const SharedWallets = ({ getSharedWallets, sharedWallets, period }) => {
  // Initial load
  useEffect(() => {
    getSharedWallets({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support both new PeriodSelector and legacy formats
  useEffect(() => {
    // For "All time" (both null), send empty strings
    if (!period?.startDate && !period?.endDate) {
      getSharedWallets({
        page: 1,
        limit: 20,
        startDate: "",
        endDate: ""
      });
    } else if (period?.startDate) {
      // For specific periods, send the actual dates
      getSharedWallets({
        page: 1,
        limit: 20,
        startDate: period?.startDate || "",
        endDate: period?.endDate || "",
      });
    }
  }, [period]);

  const handleLoadMore = (page) => {
    // Use the same logic for load more
    const payload = {
      page,
      limit: 20
    };
    
    if (!period?.startDate && !period?.endDate) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate) {
      payload.startDate = period?.startDate || "";
      payload.endDate = period?.endDate || "";
    }
    
    getSharedWallets(payload);
  };

  return (
    <DataTable
      preset="sharedWallets"
      data={{
        docs: sharedWallets?.docs || [],
        totalPages: sharedWallets?.totalPages || 0
      }}
      onLoadMore={handleLoadMore}
      loading={false}
    />
  );
};

const mapStateToProps = (state) => ({
  sharedWallets: state.appFinances.sharedWallets,
});

const mapDispatchToProps = (dispatch) => ({
  getSharedWallets: (payload) => dispatch(getSharedWallets(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SharedWallets);